// Number formatting helpers for charts.

// Compact axis labels: 1234 -> "1.2K", 5000000 -> "5M", 2500000000 -> "2.5B".
// Values below 1000 render plainly, so small-count charts are unaffected.
// Sign is preserved (for diverging axes that plot negatives below zero).
export function formatCompactNumber(value) {
    const n = Number(value);
    if (!isFinite(n)) return '';
    const abs = Math.abs(n);
    const sign = n < 0 ? '-' : '';

    if (abs < 1000) return `${sign}${abs}`;

    const units = [
        { v: 1e9, s: 'B' },
        { v: 1e6, s: 'M' },
        { v: 1e3, s: 'K' },
    ];
    for (const u of units) {
        if (abs >= u.v) {
            const scaled = abs / u.v;
            // One decimal, but drop a trailing ".0" (5.0M -> 5M). Past 100 of a
            // unit, round to whole so labels stay short (250.0K -> 250K).
            const str = scaled >= 100
                ? Math.round(scaled).toString()
                : scaled.toFixed(1).replace(/\.0$/, '');
            return `${sign}${str}${u.s}`;
        }
    }
    return `${sign}${abs}`;
}

// Full value with thousands separators, for tooltips where the exact number
// matters (e.g. "5,000,000") even though the axis shows the compact form.
export function formatFullNumber(value) {
    const n = Number(value);
    return isFinite(n) ? n.toLocaleString() : '';
}
